import { generatePath, useHistory } from 'react-router-dom'

import { useAppSelector } from 'app/hooks'
import routes from 'app/routes'

import {
  currentRootDomainIdSelector,
  rootDomainByIdSelector,
  rootDomainsDataSelector,
} from 'features/rootDomains/selectors'
import {
  ActiveCompanyMultiArrow,
  StyledMiniCompanyImgWrap,
  StyledMiniCompanyItem,
} from './styles'
import CompanyImage from 'components/Image/CompanyImage'
import { mdiChevronRight } from '@mdi/js'

interface MiniCompanySelectorProps {
  onItemClick?: () => void
}

function MiniCompanySelector(props: MiniCompanySelectorProps) {
  const history = useHistory()

  const currentRootDomainId = useAppSelector(currentRootDomainIdSelector)
  const rootDomain = useAppSelector(rootDomainByIdSelector(currentRootDomainId))
  const rootDomains = useAppSelector(rootDomainsDataSelector.data)

  const isSingleRootDomain = rootDomains?.length === 1

  if (!rootDomain) {
    return null
  }

  // Redirect to /companies if more then one rootDomain. Do nothing otherwise
  const handleDomainClick = () => {
    props.onItemClick?.()

    if (currentRootDomainId && !isSingleRootDomain) {
      const companiesPath = generatePath(routes.companies, {
        rootDomainId: currentRootDomainId,
      })
      history.push(companiesPath)
    }
  }

  return (
    <StyledMiniCompanyItem
      as="div"
      key={rootDomain.id}
      onClick={handleDomainClick}
    >
      <StyledMiniCompanyImgWrap>
        {!!rootDomain.imageUrl && (
          <CompanyImage mini src={rootDomain.imageUrl} />
        )}
      </StyledMiniCompanyImgWrap>
      {rootDomain.name}
      {!isSingleRootDomain && (
        <ActiveCompanyMultiArrow path={mdiChevronRight} size={2} />
      )}
    </StyledMiniCompanyItem>
  )
}

export default MiniCompanySelector
